<div class="container">
    <form class="form" (ngSubmit)="onReasignarSubmit()" [formGroup]="reasignarFormGroup">

        <div class="form-header">           
            <app-tree-autocomplete [dptos]="dsDepartamentos" (onSelected)="trackDepartamentoChanges($event)" class="full-width"/>
            <mat-form-field class="full-width">
                <mat-label>Servidor p&uacute;blico</mat-label>
                <input type="text" matInput formControlName="participante" [matAutocomplete]="autoParticipante"
                    (focus)="selectAllText($event)">
                <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn">
                    @for (participante of participantesFiltered | async; track participante) {
                    <mat-option [value]="participante" style="display: block;">
                        <div><span>{{participante.apellidos.trim()+" "+participante.nombres.trim()}}</span> </div>
                        <small>{{(participante.cargo||'')+" "+participante.ciruc}} </small>
                        <span class="sgd-spacer"></span>
                        <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}"
                            style="float: inline-end; margin-right: 0;">man</mat-icon>
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Fecha m&aacute;xima</mat-label>
                <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="maxDate">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <mat-form-field class="full-width">
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>
        <div style="display: flex; gap: 1rem;">
            <button class="full-width" mat-button type="button" (click)="onCancel()">
                Cancelar
            </button>
            <button class="full-width" [disabled]="!reasignarFormGroup.valid || fetchingReasignar" mat-flat-button
                type="submit">
                <div>
                    @if (fetchingReasignar) {
                    <mat-spinner diameter="20" color="warn"></mat-spinner>
                    }@else{
                    <p>Reasignar</p>
                    }
                </div>
            </button>
        </div>
    </form>

    <app-table-selected-documents [documentsInformation]="documentsInformation"></app-table-selected-documents>
</div>